import React, {useContext, useEffect, useState} from 'react'
import { useNavigate } from 'react-router'
import styled from 'styled-components'
import PimpPageHeader from '../../components/PimpPageHeader'
import Actions from '../../components/Actions'
import {getConsentReapprovedMessage, approveConsent} from "../../services";
import {AppContext} from "../../Context";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  
  .content {
    flex: 1;
    margin-left: 20px;
    margin-right: 20px;
    display: flex;
    align-items: center;
  }
  
`

export default function ApproveConsentPage({ ...props }) {
  const [content, setContent] = useState('')

  const navigate = useNavigate()
  const {employee, setEmployee} = useContext(AppContext)

  useEffect(() => {
    const fetch = async () => {
      const result = await getConsentReapprovedMessage()
      if (result) {
        setContent(result)
      }
    }
    fetch()
  }, [])

  const logout = () => {
    navigate('/logout')
    return true
  }

  const approve = async () => {
    const result = await approveConsent()
    if (result.data && result.data.approveConsent){
      setEmployee({
        ...employee,
        consentRemoved:false
      })
      navigate('/')
    }
    return true
  }

  return <Container>
    <PimpPageHeader />

    <div className="content">
      <div dangerouslySetInnerHTML={ { __html: content } }/>
    </div>

    <Actions submitTxt='OK' onSubmit={ approve }
        cancelTxt='Annuler' onCancel={ logout }
    />
  </Container>
}
